module.exports = __webpack_public_path__ + "static/media/Bicocca - DK Grey_White.66525a37.jpg";